import React, { Component } from "react";
import Input from "../../2/Controls/Input";

class CampaignNameStep extends Component {
  handleNameChange = (value) => {
    this.props.updateFormData("name", value);
  };

  render() {
    const { formData, errors } = this.props;

    // Safe way to access formData.name without optional chaining
    const nameValue = formData && formData.hasOwnProperty('name') ? formData.name : '';
    
    // Safe way to access errors.name without optional chaining
    const nameError = errors && errors.hasOwnProperty('name') ? errors.name : '';

    return (
      <div>
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#4B5563",
            marginBottom: "24px",
          }}
        >
          Campaign Name
        </h2>

        <div
          style={{
            display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
            gap: "24px",
          }}
        >
          <Input
            type="text"
            label="Campaign Name"
            placeholder="Enter campaign name"
            value={nameValue}
            onChange={this.handleNameChange}
            error={nameError}
            required
          />
        </div>
      </div>
    );
  }
}

export default CampaignNameStep;